import React, { useState, useEffect } from 'react';
import request from '@/services/request.service';
import { toFormData } from '@/utils/convert.util';
import { getLocaleWordContent } from '@/utils/language.util';

export default function ToTal() {
    const [total1, setTol1] = useState('');
    const [total2, setTol2] = useState('');

    const fetchBusinesses = () => {
        getList('ALL');
        getList('INVEST');
    };
    useEffect(fetchBusinesses, []);

    const getList = async (btype) => {
        const param = { b_type: btype }; //
        const rsp = await request
            .post('/api/bonus/bonus_hist.php', toFormData(param))
            .then((response) => response.data);
        if (rsp.result < 0) {
            alert(rsp.msg);
            return rsp;
        } else if (btype === 'ALL') {
            setTol1(rsp.total);
        } else {
            setTol2(rsp.total);
        }
    };

    return (
        <div className="inner">
            <div className="content_box">
                <div className="total">
                    <div className="d_flex">
                        <p>{getLocaleWordContent('일일보너스')} {getLocaleWordContent('누적합계')}</p>
                        <div className="box_coin">
                            <button className="b_orange btn01">{getLocaleWordContent('누적합계')}:{total1 || ''}</button>
                        </div>
                    </div>
                    <div className="d_flex">
                        <p>{getLocaleWordContent('판매수익')} {getLocaleWordContent('누적합계')}</p>
                        <div className="box_coin">
                            <button className="b_orange btn01">{getLocaleWordContent('누적합계')}:{total2 || ''}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
